<template>
  <div v-if="value" v-bsl="value">
    <div class="base-overlay">
      <div class="onboarding-mobile onboarding-mobile--bottom">
        <div class="close-button" @click.prevent="close">
          <img
            class="show icon-close-button"
            src="@/assets/images/popup/close.png"
            alt="Zamknij"
          />
        </div>
        <h3>{{$t('onboarding.homework.title')}}</h3>
        <p>
          {{$t('onboarding.homework.content')}}
        </p>
        <div class="flex justify-center w-full">
          <button class="swiper-button" @click.prevent="lastStep">
            {{$t('onboarding.homework.btn')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'GradesMobile',
  props: {
    value: {
      required: true,
    },
  },
  computed: {
    ...mapState('students', ['student']),
  },
  methods: {
    ...mapActions('onboarding', ['setOnboardingProperty']),

    closeOnboardingTag() {
    },

    acceptOnboardingTag() {
    },

    close() {
      this.closeOnboardingTag();
      this.setTourCookie();
      this.$emit('input', !this.value);
      Event.$emit('hideClassList');
      Event.$emit('cancelTour');
      Event.$off('cancelTour');
    },
    lastStep() {
      this.acceptOnboardingTag();
      this.setTourCookie();
      Event.$emit('cancelTour');
      this.$emit('input', !this.value);
      Event.$off('cancelTour');
    },

    getDateWithYearlyOffset(years) {
      return moment().add(years, 'y').toDate();
    },

    setTourCookie() {
      if (this.student?.id) {
        this.setOnboardingProperty({ deviceType: 'mobile', property: 'singleHomework', value: true });
      }
    },

    startOnboarding() {
      const tour = this.$shepherd({
        useModalOverlay: true,
        defaultStepOptions: {
          cancelIcon: {
            enabled: true,
          },
        },
      });

      tour.addStep({
        beforeShowPromise() {
          return new Promise((resolve) => {
            setTimeout(() => {
              window.scrollTo(0, 0);
              resolve();
            }, 500);
          });
        },
        canClickTarget: false,
      });

      tour.start();

      Event.$on('cancelTour', () => {
        tour.cancel();
      });
    },
  },

  beforeDestroy() {
    Event.$off('cancelTour');
  },

  watch: {
    value(value) {
      if (value) {
        this.startOnboarding();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.base-overlay {
  @apply fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99998;
  overflow-y: auto;
  animation: fade 0.5s ease-in-out both;
}
.onboarding-mobile {
  @apply fixed pt-4 px-6 pb-8 bg-white text-black w-full text-center;
  border-radius: 20px;
  top: 40%;
  left: 50%;
  z-index: 99;
  transform: translate(-50%, -50%);
  min-height: 200px;
  max-width: calc(100% - 20px);
  max-height: calc(100% - 20px);
  &--bottom {
    top: auto;
    bottom: 2%;
    transform: translate(-50%, 0);
  }
  h3 {
    @apply font-bold text-2xl pb-3;
    padding-top: 38px;
  }
  p {
    @apply text-base pb-8;
    line-height: 18px;
  }
  .close-button {
    @apply cursor-pointer absolute text-center;
    z-index: 99999;
    height: 30px;
    width: 30px;
    top: 16px;
    right: 24px;
    background-image: url("~@/assets/images/onboarding/close.svg");
    background-repeat: no-repeat;
    background-position: center;
    img {
      display: none;
    }
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>

<style lang="scss">
.swiper-pagination-bullet {
  width: 14px;
  height: 14px;
  border: 1px solid #000;
  background: #fff;
  opacity: 0.3;
}

.swiper-pagination-bullet-active {
  @apply bg-blue;
  border: 1px solid #3e9bd3;
  opacity: 1;
}

.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 8px;
}

.swiper-button {
  @apply block bg-pink-main text-white text-lg px-12 cursor-pointer font-bold;
  line-height: 40px;
  border-radius: 100px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  &:hover {
    @apply bg-pink-dark-main text-white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
  &:not(:disabled):hover {
    @apply text-white bg-pink-dark-main;
  }
}
</style>
